import { TextBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/textBlock/textBlock.layout';
import { StyleguideExample, StyleguidePart } from '@shared/Hoppinger.Styleguide/Frontend';
import * as React from 'react';
import { dummyData, randomTitle } from '../../../config/dummyData';

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentsTextBlock = () => (
  <>
    <StyleguidePart title="Default" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentTextBlock />
      </StyleguideExample>
    </StyleguidePart>
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentTextBlock = (props: { label?: string; title?: string; intro?: string; text?: string }) => (
  <TextBlockLayout
    id='text-block-example'
    title={props.title || randomTitle()}
    intro={props.intro || dummyData.intro}
    text={props.text || dummyData.wysiwyg}
    primaryUpdater={dummyData.primaryUpdater}
    secondaryUpdater={dummyData.secondaryUpdater}
    showUpdaterAsLink={false}
  />
)
